import api from './api';

const getHolidayDateThisYear = () =>
  api.get('https://api-harilibur.vercel.app/api', {}, false, false, false);

export default {
  getHolidayDateThisYear,
};
